import { atom, computed } from 'nanostores';

import type { CopilotComposerMode } from '@/features/copilot/lib';

import { $copilotActiveTab } from './copilotPanel';

/**
 * Optional manual override for the composer mode.
 * When null, the mode is derived from the active tab.
 */
export const $copilotComposerModeOverride = atom<CopilotComposerMode | null>(null);

function composerModeFromActiveTab(activeTab: string): CopilotComposerMode {
  switch (activeTab) {
    case 'notepad':
      return 'internalNotes';
    default:
      return 'copilot';
  }
}

/**
 * The effective composer mode for the copilot panel.
 * Derived from the active tab unless a manual override is set.
 */
export const $effectiveCopilotComposerMode = computed(
  [$copilotActiveTab, $copilotComposerModeOverride],
  (activeTab, override) => override ?? composerModeFromActiveTab(activeTab)
);

/**
 * Clear the composer mode override. Called automatically when the active tab changes.
 */
export function clearComposerModeOverride(): void {
  $copilotComposerModeOverride.set(null);
}

// Side-effect: reset override whenever the active tab changes.
$copilotActiveTab.listen(() => {
  clearComposerModeOverride();
});
